import { Common } from './common.model';
import { TicketType } from './ticket.model';

export type AssignmentGroupConfigScope = 'CELL' | 'CUSTOMER' | 'PROJECT';

export class AssignmentGroupConfig extends Common {
    public scope: AssignmentGroupConfigScope;
    public entityId: string;
    public ticketType: TicketType;
    public period: 'HO' | 'HNO';
    public assignmentType: string;
    public assignmentGroup: string;

    constructor(data) {
        super(data);
        this.scope = data.scope;
        this.entityId = data.entityId;
        this.ticketType = data.ticketType;
        this.period = data.period;
        this.assignmentType = data.assignmentType;
        this.assignmentGroup = data.assignmentGroup;
    }
}

export enum AssignmentGroupConfigScopePriority {
    CELL = 1,
    CUSTOMER = 2,
    PROJECT = 3,
}
export const assignmentGroupConfigPeriod = ['HO', 'HNO'];

export const assignmentGroupConfigTypeShort = {
    [TicketType.INCIDENT]: 'INC',
    [TicketType.SERVICE_REQUEST]: 'SRQ',
    [TicketType.PROBLEM]: 'PRB',
};

export const assignmentTypes = {
    FIRST_LINE: 'First Line',
    INFRA_FIRSTLINE: 'Infra first line',
    LINUX: 'Linux - OS & Applications',
    WINDOWS: 'Windows - OS & Applications',
    AS400: 'AS400 - OS & Applications',
    BDD: 'Bases de données',
    INFRA_RESEAU: 'Infra Réseau',
    INFRA_STOCKAGE: 'Infra Stockage',
    INFRA_SAVE: 'Infra Sauvegarde',
    INFRA_VIRTU: 'Infra Virtualisation',
    INFRA_DATACENTER: 'Infra Datacenter',
    OPS_4_OPS: 'Ops4Ops - Outils internes',
    CODE: 'CoDE - Outils internes',
    SECU: 'Sécurité',
    CLOUD_EXPERTISE: 'Expertise Cloud',
    VDI: 'Virtualisation d\'applications',
    APPLICATION_DEVELOPMENT: 'Développement applicatif',
    APPLICATION_MANAGER: 'Gestionnaire applicatif',
    CONTINUOUS_INTEGRATION: 'Intégration continue',
    AIX_OS: 'AIX - OS',
};

export type AssignmentTypes = keyof typeof assignmentTypes;
